<template>
    <div class="cartcontroll notranslate">
        <transition name="slide-fade" v-show="food.groupId == null">
            <mu-button icon color="primary" :class="packageType == 0 ? 'decrease' : 'decrease-buffet'"
                v-show="food.quantity" @click="decreaseCart">
                <mu-icon value="remove_circle"></mu-icon>
            </mu-button>
        </transition>
        <div :class="packageType == 0 ? 'count' : 'count-buffet'" v-show="food.quantity">{{ food.quantity }}</div>

        <mu-button icon color="primary" :class="(addType === true || food.unAdd) ? 'form-onlyread' : 'add'"
            @click="addCart" v-show="(food.groupId == null) || (food.groupId != null && food.quantity)">
            <mu-icon value="add_circle"></mu-icon>
        </mu-button>

        <mu-badge :content="food.unPayTip" v-if="food.unPayTip"
            style="position:absolute;width:180px;left:-150px;top:20px;z-index: 10000;"></mu-badge>

        <mu-badge :content="getWith()" color="#da5b3a" badge-class="badge-class" @click="openTasteSheet(food.groupId)"
            v-if="(addType === false && !food.unAdd)" v-show="food.groupId != null && !food.quantity"></mu-badge>

        <mu-bottom-sheet :open.sync="open" style="overflow-y: auto; height: 80%;">
            <mu-list @item-click="closeTasteSheet">
                <mu-sub-header
                    style="padding-left: 10px;font-size: 20px;font-weight: 600;line-height: 24px;padding-top: 5px;">{{
                        food.foodName }}</mu-sub-header>
                <mu-icon value="close" size="20" class="close-icon notranslate" @click="closeTasteSheet"></mu-icon>
                <div style="margin-bottom: 20px;" v-for="(parentItem, index) in foodAttribute" :key="index">
                    <div
                        style="font-size: 14px;color: #909399;line-height: 20px;text-align: left;padding-left: 10px;padding-top: 10px;">
                        {{ parentItem.attributeName }}</div>
                    <div v-for="item in parentItem.children" @click="selectTastes(item)" :key="item.id"
                        :class="item.isChoice ? 'stateChoose' : 'stateNotChoose'">
                        {{ item.attributeName }}&nbsp;&nbsp;
                        <span>|</span>
                        &nbsp;&nbsp;
                        <span style="color: #f01414;font-size: 13px;font-weight:bold;">{{
                            getAttributeDisplayPrice(parentItem, item) }} {{ seller.unit }}</span>
                    </div>
                </div>
                <div
                    style="padding-left: 20px;padding-right: 20px;margin-bottom: 20px;line-height: 40px;background-color:#F2F6FC;">
                    {{ $t('orderList.choice') }} : {{ food.decideName }}
                </div>
                <div style="padding-left: 20px;">
                    <div style="text-align: right;padding-right: 20px;">
                        <span style="font-weight:bold;font-size: 14px;">
                            {{ $t('orderList.total') }}
                        </span>&nbsp;
                        <span style="color: #f01414;font-size: 20px;font-weight: 600;">
                            {{ food.payAmount }}
                        </span>
                        <span style="color: #f01414;font-size: 14px;">
                            {{ seller.unit }}
                        </span>
                    </div>

                </div>
                <div style="padding: 20px;margin-bottom: 20px;">
                    <mu-button color="primary" large full-width @click="sureTasteSheet"
                        style="background-color:#da5b3a;text-transform: unset;">
                        {{ $t('common.sure') }}
                    </mu-button>
                </div>
            </mu-list>
        </mu-bottom-sheet>

        <mu-bottom-sheet :open.sync="openMulSelect" style="overflow-y: auto; height: 80%;">
            <mu-list>
                <mu-sub-header
                    style="padding-left: 10px;font-size: 20px;font-weight: 600;line-height: 24px;padding-top: 5px;">
                    {{ food.foodName }}
                </mu-sub-header>
                <mu-icon value="close" size="20" class="close-icon notranslate" @click="closeSheet"></mu-icon>

                <div class="order-container" style="max-width: 500px; margin: 0px auto; padding: 15px;">
                    <!-- 配置区 -->
                    <div class="config" style="margin-bottom:15px; padding-bottom:10px; border-bottom:1px solid #eee;">
                        <div style="margin-top:5px;">{{ $t('orderList.maxiNum') }}:<input v-model.number="maxPerPerson"
                                type="number" min="1" style="width:60px;"></div>
                    </div>

                    <!-- 所有人的选择项 + 编辑按钮 -->
                    <div v-if="step === 'list'" class="person-add-area">
                        <div v-for="(person, idx) in selectedPersons" :key="idx" style="margin-bottom:12px;">
                            <!-- 编辑按钮：显示人名 / 第X人 -->
                            <button class="add-person-btn" @click="editPersonSelect(idx)"
                                style="margin-bottom:6px;background-color: rgb(63, 81, 181);">
                                {{ person.name || `Person ${idx + 1}` }}
                            </button>

                            <!-- 已选内容 -->
                            <div
                                style="padding: 10px; border:1px solid #eee; border-radius:8px; background:#f9f9f9;display:flex;">
                                <div v-for="(attr, attrIdx) in person.attrs" :key="attrIdx"
                                    style="color:#666; margin-bottom:4px; ">
                                    {{ attr.num }} {{ attr.attributeName }}<span
                                        style="padding-left: 2px;padding-right:10px;"
                                        v-if="attrIdx < (person.attrs.length - 1)">,</span>
                                </div>
                            </div>
                        </div>

                        <!-- 新增下一个人（永远显示） -->
                        <button class="add-person-btn" @click="openPersonSelect"
                            style="background:#4caf50; margin-top:10px;">
                            + Add Person {{ selectedPersons.length + 1 }}
                        </button>
                    </div>

                    <!-- 2. 选择状态：当前人的口味选择页 -->
                    <div v-if="step === 'select'" class="person-select-area">
                        <div style="font-size: 18px; font-weight: bold; margin-bottom: 15px;">
                            Person {{ currentPersonIdx + 1 }}
                        </div>

                        <!-- 口味列表（带数量输入） -->
                        <div class="attribute-list" style="margin-bottom: 20px;">
                            <div v-for="(item, index) in mulList" :key="index" class="attribute-item"
                                style="display: flex; align-items: center; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid #eee;">
                                <span class="attribute-name">{{ item.attributeName }}</span>
                                <div
                                    style="display:flex;align-items:center;border:1px solid #eaeefb;border-radius:8px;overflow:hidden;width:140px;">
                                    <button
                                        @click="setAttrNum(index, Math.max(0, (currentPersonAttrs[index] && currentPersonAttrs[index].num || 0) - 1))"
                                        style="width:40px;height:36px;border:none;background:#f7f8fa;font-size:16px;color:#333;">-</button>
                                    <input v-model.number="currentPersonAttrs[index].num" type="number" min="0"
                                        :max="maxPerPerson" @change="validateAttrNum(index)"
                                        style="flex:1;height:36px;border:none;text-align:center;font-size:14px;outline:none;">
                                    <button
                                        @click="setAttrNum(index, Math.min(maxPerPerson, (currentPersonAttrs[index] && currentPersonAttrs[index].num || 0) + 1))"
                                        style="width:40px;height:36px;border:none;background:#f7f8fa;font-size:16px;color:#333;">+</button>
                                </div>
                            </div>
                        </div>

                        <!-- 归属人输入框 -->
                        <div style="margin-bottom: 20px;">
                            <label style="font-size:15px;color:#333;display:block;margin-bottom:10px;">{{
                                $t('orderList.who') }}</label>
                            <input v-model="currentPersonName" :placeholder="$t('orderList.nullRemark')"
                                style="width:100%;height:46px;padding:0 12px;border:1px solid #eaeefb;border-radius:8px;font-size:15px;outline:none;">
                        </div>

                        <!-- 操作按钮 -->
                        <div style="display: flex; gap: 10px;">
                            <mu-button @click="cancelPersonSelect" style="flex:1; background:#eee; color:#333;">
                                {{ $t('common.cancel') }}
                            </mu-button>
                            <mu-button color="primary" @click="confirmPersonSelect" style="flex:1; background:#da5b3a;">
                                {{ $t('common.ok') }}
                            </mu-button>
                        </div>
                    </div>

                    <!-- 底部确认按钮 -->
                    <div style="padding: 20px 0; margin-top: 20px;" v-if="isSure">
                        <mu-button color="primary" large full-width @click="sureMulSelect"
                            style="background-color:#da5b3a;text-transform: unset;">
                            {{ $t('common.sure') }}
                        </mu-button>
                    </div>
                </div>
            </mu-list>
        </mu-bottom-sheet>

    </div>
</template>

<script>
import Vue from 'vue'
import { eventBus } from '../utils/event-bus'

export default {
    props: {
        packageType: {
            type: Number,
            default: 0
        },
        food: {
            type: Object
        },
        addType: {
            type: Boolean
        },
        personNum: {
            type: Number,
            default: 1
        },
    },
    data() {
        return {
            foodAttributeAll: [],
            foodAttribute: [],
            open: false,
            openMulSelect: false,
            tableOrderInfo: {},
            seller: {},
            maxPerPerson: 1,
            currAttribute: '',

            showDialog: false,
            selectedList: [],
            mulList: [],
            step: 'list', // list / select
            selectedPersons: [],
            tempSelectList: [],
            currentPersonIdx: 0,
            currentPersonName: '',
            currentPersonAttrs: [],
            personCount: 99,
            totalMax: 0,
            isSure: true,
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
        globalUsed() {
            let num = 0
            this.selectedPersons.forEach(p => {
                p.items.forEach(it => num += it.num)
            })
            return num
        }
    },
    methods: {
        // 获取某个用户已点份数
        getUserUsed(user) {
            let num = 0
            this.selectedPersons.forEach(p => {
                p.attrs.forEach(it => num += it.num)
            })
            return num
        },
        // 删除一项
        deleteItem(index) {
            const item = this.selectedList[index]
            this.globalUsed -= item.num
            this.selectedList.splice(index, 1)
        },
        addCart(e) {
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1);
                if (this.food.chargedOnce == 1 && this.food.payAmount > 0) {
                    var tips = this.$t("orderList.chargedOnceTips");
                    if (window.localStorage.getItem('oneTimeCharge') != undefined && window.localStorage.getItem('oneTimeCharge') != null && window.localStorage.getItem('oneTimeCharge') != '') {
                        tips = window.localStorage.getItem('oneTimeCharge');
                    }
                    this.$alert(tips, this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                }
            } else {
                this.food.quantity += 1;
            }

            // 优化体验，异步传递当前点击文档节点
            this.$nextTick(() => {
                eventBus.$emit('addcart', e.target)
            })
        },
        decreaseCart() {
            if (this.food.quantity) {
                this.food.quantity--
                if (this.food.quantity == 0) {
                    Vue.set(this.food, 'payAmount', this.food.price)
                }
            }
        },
        getWith() {
            return this.$t('orderList.with');
        },
        // 根据父属性 ExtJson 中的 priceIncrease 字段决定展示价格
        // priceIncrease === false：仅显示 item.attributePrice
        // 其他情况（ExtJson 为空、无内容、无 priceIncrease、priceIncrease=true）：显示 food.price + item.attributePrice
        getAttributeDisplayPrice(parentItem, item) {
            let addFoodPrice = true;
            if (parentItem && parentItem.extJson) {
                try {
                    const ext = typeof parentItem.extJson === 'string'
                        ? JSON.parse(parentItem.extJson)
                        : parentItem.extJson;
                    if (ext && ext.priceIncrease === false) {
                        addFoodPrice = false;
                    }
                } catch (e) {
                }
            }
            return addFoodPrice
                ? (this.food.price + item.attributePrice)
                : item.attributePrice;
        },
        selectTastes(it) {
            var decideNameArr = [];
            var extPrice = 0;
            this.foodAttribute.forEach((item) => {
                if (item.id == it.parentId) {
                    item.children.forEach((item1) => {
                        if (it.id == item1.id) {
                            if (!item1.isChoice) {
                                item1.isChoice = true;
                                extPrice += item1.attributePrice;
                                decideNameArr.push(item1.attributeName);
                            }
                            else {
                                item1.isChoice = !item1.isChoice;
                            }
                        }
                        else {
                            if (item.model == 1) {
                                item1.isChoice = false;
                            }
                            else {
                                if (item1.isChoice) {
                                    extPrice += item1.attributePrice;
                                    decideNameArr.push(item1.attributeName);
                                }
                            }
                        }
                    })
                }
                else {
                    item.children.forEach((item1) => {
                        if (item1.isChoice) {
                            extPrice += item1.attributePrice;
                            decideNameArr.push(item1.attributeName);
                        }
                    })
                }
            })
            // 根据 extJson 中 priceIncrease 决定是否加入 food 基础价
            let addFoodPrice = true;
            for (let i = 0; i < this.foodAttribute.length; i++) {
                const attr = this.foodAttribute[i];
                let hasSelected = false;
                for (let j = 0; j < attr.children.length; j++) {
                    if (attr.children[j].isChoice) {
                        hasSelected = true;
                        break;
                    }
                }
                if (hasSelected && attr.extJson) {
                    try {
                        const ext = typeof attr.extJson === 'string' ? JSON.parse(attr.extJson) : attr.extJson;
                        if (ext && ext.priceIncrease === false) {
                            addFoodPrice = false;
                            break;
                        }
                    } catch (e) {}
                }
            }
            if (addFoodPrice) {
                this.food.payAmount = parseFloat(Number((this.food.price * this.food.actDiscount) + extPrice).toFixed(0));
            } else {
                this.food.payAmount = parseFloat(Number(extPrice).toFixed(0));
            }
            let t = decideNameArr.join(',');
            if (this.food.decideName == null) {
                Vue.set(this.food, 'decideName', t)
            } else {
                this.food.decideName = t;
            }
        },
        sureTasteSheet() {
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1)
            } else {
                this.food.quantity += 1
            }
            this.open = false;
        },
        closeTasteSheet() {
            this.open = false;
        },
        openTasteSheet(groupId) {
            this.foodAttribute = [];
            Vue.set(this.food, 'decideName', null)
            this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.$get('QRCodeOrder/GetAllFoodCustomAttributeList', { restaurantId: this.tableOrderInfo.restaurantId })
                .then(response => {
                    if (response.code == 200) {
                        this.foodAttributeAll = response.data;;
                        var arr = response.data.filter(item => {
                            return groupId.indexOf(item.id) > -1
                        })
                        arr.forEach((parentItem) => {
                            parentItem.children = response.data.filter(item => {
                                return item.parentId == parentItem.id;
                            })
                        })
                        if (arr.length > 0) {
                            this.foodAttribute = arr;
                            if (this.foodAttribute[0].children.length > 0) {
                                this.selectTastes(this.foodAttribute[0].children[0]);
                            }
                            if (arr[0].model == 2) {
                                this.mulList = arr[0].children;
                                this.openMulSelect = true;
                                this.maxPerPerson = this.food.perMaxCopies;
                                if (this.maxPerPerson == null || this.maxPerPerson == 0) {
                                    this.maxPerPerson = 1;
                                }
                                this.totalMax = this.personNum * this.maxPerPerson
                            }
                        }
                        if (!this.openMulSelect) {
                            this.open = true;
                        }
                    }
                });
        },
        changeData() {
            this.totalMax = this.personNum * this.maxPerPerson
        },
        toSelectPage() {
            const arr = []
            this.mulList.forEach(item => {
                arr.push({
                    attributeId: item.attributeId,
                    attributeName: item.attributeName,
                    num: 0
                })
            })
            this.tempSelectList = arr
            this.currentPersonName = ''
            this.step = 'select'
        },
        addNum(index) {
            const item = this.tempSelectList[index]
            if (item.num >= this.maxPerPerson) return
            item.num += 1
            this.$set(this.tempSelectList, index, item)
        },
        // 关闭多人选择弹窗
        closeSheet() {
            this.openMulSelect = false
            this.step = 'list'
            this.selectedPersons = []
        },
        // 打开当前人选择界面
        openPersonSelect() {
            this.isSure = false,
            this.step = 'select'
            this.currentPersonIdx = this.selectedPersons.length
            this.currentPersonName = ''
            this.currentPersonAttrs = this.mulList.map(item => ({
                attributeId: item.id,
                attributeName: item.attributeName,
                num: 0
            }))
        },
        // 设置口味数量（总数限制）
        setAttrNum(index, num) {
            // 计算当前已经选了多少
            const currentTotal = this.currentPersonAttrs.reduce((sum, it) => sum + (it.num || 0), 0)
            // 即将变化的数量
            const diff = num - (this.currentPersonAttrs[index].num || 0)
            const newTotal = currentTotal + diff

            // 超过总上限 → 不让加
            if (newTotal > this.maxPerPerson) {
                this.$alert(this.$t("orderList.maxiNum") + ": " + this.maxPerPerson, this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                return;
            }
            if (num < 0) return

            let item = this.currentPersonAttrs[index]
            item.num = num
            this.$set(this.currentPersonAttrs, index, item)
        },
        // 校验数量合法性（总数限制）
        validateAttrNum(index) {
            let item = this.currentPersonAttrs[index]
            const currentTotal = this.currentPersonAttrs.reduce((sum, it) => sum + (it.num || 0), 0)
            const diff = item.num - (this.currentPersonAttrs[index].num || 0)
            const newTotal = currentTotal + diff

            if (item.num < 0) item.num = 0
            if (newTotal > this.maxPerPerson) {
                item.num = this.maxPerPerson - currentTotal + (this.currentPersonAttrs[index].num || 0)
            }

            this.$set(this.currentPersonAttrs, index, item)
        },
        // 取消当前人选择
        cancelPersonSelect() {
            this.isSure = true;
            this.step = 'list';
        },
        confirmPersonSelect() {
            let hasSelect = this.currentPersonAttrs.some(a => a.num > 0)
            if (!hasSelect) {
               this.$alert(this.$t("orderList.needMax1"), this.$t("common.alert"), { okLabel: this.$t("common.sure") });
               return
            }
            let attrs = this.currentPersonAttrs.filter(a => a.num > 0)

            // 编辑模式
            if (this.currentPersonIdx !== undefined && this.selectedPersons[this.currentPersonIdx]) {
                this.selectedPersons[this.currentPersonIdx] = {
                    name: this.currentPersonName,
                    attrs: attrs
                }
            }
            // 新增模式
            else {
                this.selectedPersons.push({
                    name: this.currentPersonName,
                    attrs: attrs
                })
            }
            this.isSure = true;
            this.step = 'list'
        },
        // 编辑某个人的选择
        editPersonSelect(idx) {
            this.isSure = false;
            this.currentPersonIdx = idx;
            let person = this.selectedPersons[idx];
            this.currentPersonName = person.name || '';
            this.currentPersonAttrs = this.mulList.map(item => {
                const oldAttr = person.attrs.find(a => a.attributeId === item.id);
                return {
                    attributeId: item.id,
                    attributeName: item.attributeName,
                    num: oldAttr ? oldAttr.num : 0, 
                };
            });

            this.step = 'select';
        },
        sureMulSelect() {
           
            var result='';
            this.selectedPersons.forEach(p => {
                let name=p.name || 'Person ' + (this.selectedPersons.length);
                 var res = []
                p.attrs.forEach(i => {
                    res.push(
                        i.num +"x "+ i.attributeName,
                    )
                })
                result+=name+':'+res.join('  ')+';';
            })
            if (!this.food.quantity) {
                Vue.set(this.food, 'quantity', 1)
            } else {
                this.food.quantity += 1
            }
            this.food.decideName = result;
            this.openMulSelect = false
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .cartcontroll {
        font-size: 0;
    }

        .cartcontroll .decrease,
        .cartcontroll .add {
            display: inline-block;
            font-size: 24px;
            width: 30px;
            height: 30px;
            color: #da5b3a;
            padding: 6px;
        }


        .cartcontroll .decrease-buffet,
        .cartcontroll .add-buffet {
            display: inline-block;
            font-size: 24px;
            width: 30px;
            height: 30px;
            color: #fff;
            padding: 6px;
        }


        .cartcontroll .count {
            display: inline-block;
            vertical-align: top;
            font-size: 18px;
            font-weight:600;
            width: 30px;
            line-height: 30px;
            text-align: center;
            color: #da5b3a;
        }

        .cartcontroll .count-buffet {
            display: inline-block;
            vertical-align: top;
            font-size: 12px;
            width: 20px;
            line-height: 30px;
            text-align: center;
            color: #fff;
        }

    .cartcontroll,
    .slide-fade-enter-active {
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
    }

    .slide-fade-leave-active {
        -webkit-transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        /* .slide-fade-leave-active for below version 2.1.8 */
        -webkit-transform: translateX(24px) rotate(360deg);
        transform: translateX(24px) rotate(360deg);
        opacity: 0;
    }

    .foods-wrapper {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        overflow-y: scroll;
    }

     .foods-wrapper h1 {
        margin: 0px;
    }

     .foods-wrapper .title {
        padding-left: 14px;
        border-left: 2px solid #d9dde1;
        font-size: 12px;
        height: 26px;
        line-height: 26px;
        color: #93999f;
        background-color: #f3f5f7;
    }

     .foods-wrapper .food-item {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin: 5px;
        padding-bottom: 10px;
        margin-right: 10px;
        position: relative;
    }

         .foods-wrapper .food-item:after {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            border-top: 1px solid rgba(7,17,27,0.1);
            content: '';
        }

         .foods-wrapper .food-item:last-child:after {
            border-top: 0;
        }

         .foods-wrapper .food-item .icon {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 57px;
            flex: 0 0 57px;
            margin-right: 10px;
        }

         .foods-wrapper .food-item .content {
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            margin-left: 5px;
        }

             .foods-wrapper .food-item .content .name {
                margin: 2px 0 8px 0;
                height: 12px;
                line-height: 12px;
                font-size: 14px;
                color: #07111b;
            }

             .foods-wrapper .food-item .content .description,
             .foods-wrapper .food-item .content .extra {
                font-size: 10px;
                line-height: 10px;
                color: #93999f;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                height: 10px;
                line-height: 10px;
            }

                 .foods-wrapper .food-item .content .extra .count {
                    margin-right: 12px;
                    line-height: 10px;
                }

                 .foods-wrapper .food-item .content .extra .rating {
                    line-height: 10px;
                }

             .foods-wrapper .food-item .content .price .now {
                font-size: 12px;
                color: #f01414;
                font-weight: 700;
                line-height: 24px;
                padding:5px;
            }

             .foods-wrapper .food-item .content .price .old {
                font-size: 12px;
                text-decoration: line-through;
                color: #93999f;
                font-weight: 700;
                line-height: 24px;
            }

             .foods-wrapper .food-item .content .cart-wrapper {
                position: absolute;
                right: 0;
                bottom: 12px;
            }

    .form-onlyread {
        pointer-events: none;
        background: #e0e0e0;
    }

    .material-icons {
    font-size:36px;
    }
    .badge-class {
    font-size:18px;
    }
    .stateChoose {
        height: 32px;
        background: #fffbf2;
        border: 1px solid #ef9350;
        border-radius: 10px;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        color: #DA5B3A;
        padding: 0px 20px 0px 20px;
        line-height: 32px;
        margin-bottom: 5px;
        margin-top: 5px;
        margin-left: 10px;
        margin-right: 10px;
        width:auto; 
        text-align: left;
        display: inline-block;
      }
       
      .stateNotChoose {
        height: 32px;
        background: #ffffff;
        border: 1px solid #E4E7ED;
        border-radius: 10px;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #363636;
        line-height: 32px;
        padding: 0px 20px 0px 20px;
        margin-bottom: 5px;
        margin-top: 5px;
        margin-left: 10px;
        margin-right: 10px;
        text-align: left;
        display: inline-block;
      }

      /* 菜品列表布局 */
.attribute-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  padding: 0 4px;
}

/* 按钮主体样式 —— 完全贴合 mu-bottom-sheet 底部弹窗风格 */
.attribute-btn {
  flex: none; /* 关键：不自动撑满 */
  min-width: 100px;
  padding: 10px 16px; /* 左右内边距足够，文字长就自动变宽 */
  height: 44px;
  background: #ffffff;
  border: 1px solid #e5e6eb;
  border-radius: 12px;
  font-size: 14px;
  color: #333;
  white-space: nowrap; /* 文字不换行 */
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* 鼠标/手指按下效果 */
.attribute-btn:active {
  background: #f5f6f7;
  transform: scale(0.96);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

/* 禁用态（达到总上限）*/
.attribute-btn:disabled {
  background: #f7f8fa;
  color: #c9c9c9;
  border-color: #eee;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}
/* 已选列表容器 */
.selected-list {
  margin-bottom: 20px;
  padding: 0 4px;
}
/* 标题 */
.selected-title {
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
}
.selected-title span {
  color: #999;
  font-size: 13px;
  margin-left: 6px;
}
/* 空状态 */
.selected-empty {
  color: #ccc;
  font-size: 14px;
  padding: 10px 0;
  text-align: center;
}
/* 每一项卡片 */
.selected-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fafbfc;
  border: 1px solid #f0f1f5;
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 8px;
}
/* 左侧信息 */
.selected-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333;
}
/* 菜品名称 */
.food-name {
  font-weight: 500;
}
/* 归属人标签 */
.user-tag {
  background: #e8f3ff;
  color: #26a2ff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}
/* 份数 */
.num {
  color: #666;
  font-size: 13px;
}
/* 删除按钮 */
.del-btn {
  background: #fff0f0;
  color: #fa3f3f;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
}
.del-btn:active {
  background: #ffe0e0;
}

.add-person-btn {
  width: 100%;
  padding: 12px;
  background: #da5b3a;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
}
.add-person-btn:disabled {
  background: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/CartControl.vue